import type {OAuthSession} from "@atproto/oauth-client-browser";
import {Avatar, Card, Group, Stack, Text, Title} from "@mantine/core";
import {formatDateShort} from "@/app/utils/dateUtils";

export function ProfileHeader(props: {session: OAuthSession}) {
  const {session} = props;
  // Extract DID and handle from session
  const did = session.sub;
  const handle = `${session.sub.replace("did:plc:", "").substring(0, 16)}...`; // Simplified for now

  return (
    <Card withBorder radius="lg" p="xl" className="glass-card" bg="transparent">
      <Group gap="xl" align="center">
        {/* Avatar placeholder */}
        <Avatar
          size={80}
          radius="xl"
          color="violet"
          variant="gradient"
          gradient={{from: "indigo", to: "violet", deg: 45}}
        >
          {did.substring(8, 10).toUpperCase()}
        </Avatar>

        {/* User info */}
        <Stack gap={4} style={{flex: 1, minWidth: 0}}>
          <Title order={2} size="h2">
            {handle}
          </Title>
          <Text size="xs" c="dimmed" style={{wordBreak: "break-all"}}>
            {did}
          </Text>
          <Text size="sm" c="dimmed">
            Member since {formatDateShort(new Date())}
          </Text>
        </Stack>
      </Group>
    </Card>
  );
}
